import { Avatar } from "@mui/material";

const ChatHeader = ({ selectedChat }) => {
  return (
    <>
      <div className="settings-tray mb-2">
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div className="my-auto d-flex">
            <Avatar
              alt={selectedChat?.receiverName}
              src={selectedChat?.receiverImage}
            />
            <div className="mx-2 my-auto">
              <p className="fw-bold mb-0">{selectedChat?.receiverName}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatHeader;
